// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.externaltour.RentalManagerUserPropertyExternalTourV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyExternalTourAddForListingResponseV2WebDto,
  UserPropertyExternalTourAddForListingV2RequestDto,
  UserPropertyExternalTourAddForModelResponseV2WebDto,
  UserPropertyExternalTourAddForModelV2RequestDto,
  UserPropertyExternalTourRemoveFromListingV2RequestDto,
  UserPropertyExternalTourRemoveFromModelV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Path =
  '/api/web/v2/users/properties/externalTour/addExternalTourForListing';

/**
 * Associate an external tour to a building/listing
 */
export const RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing = (
  postData: UserPropertyExternalTourAddForListingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyExternalTourAddForListingV2RequestDto,
    UserPropertyExternalTourAddForListingResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Path =
  '/api/web/v2/users/properties/externalTour/addExternalTourForModel';

/**
 * Associate an external tour to a unit/floor plan
 */
export const RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel = (
  postData: UserPropertyExternalTourAddForModelV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyExternalTourAddForModelV2RequestDto,
    UserPropertyExternalTourAddForModelResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyExternalTourV2WebApiHandler_addExternalTourForModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Path =
  '/api/web/v2/users/properties/externalTour/removeExternalTourFromListing';

/**
 * Remove an external tour from a building/listing
 */
export const RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing = (
  postData: UserPropertyExternalTourRemoveFromListingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyExternalTourRemoveFromListingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Path =
  '/api/web/v2/users/properties/externalTour/removeExternalTourFromModel';

/**
 * Remove an external tour from a unit/floor plan
 */
export const RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel = (
  postData: UserPropertyExternalTourRemoveFromModelV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyExternalTourRemoveFromModelV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyExternalTourV2WebApiHandler_removeExternalTourFromModel_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
